export function resolve(service: string, target: string | object) {
    if (typeof target === 'object') {
        return service + JSON.stringify(target);
    }
    return service + target;
}